import React from 'react';

import { GridPageLayout } from '@lux/grid';
import { Message, MessageType } from '@lux/message';
import { FlashMessage as PegasusFlashMessage } from '@pegasus/ui-flashmessages';

import { convertFlashMessageToAlertType } from './helpers';

type FlashMessageProps = {
    flashMessages: PegasusFlashMessage[];
};

type FlashMessageWithText = PegasusFlashMessage & {
    text: string;
    title: string;
};

export const FlashMessage: React.FC<FlashMessageProps> = ({ flashMessages }) => (
    <GridPageLayout>
        <div className="mb-sm mx-[3%]">
            {flashMessages.map((message: FlashMessageWithText) => (
                <Message
                    key={message?.messageId}
                    type={MessageType.INLINE}
                    purpose={convertFlashMessageToAlertType(message?.type)}
                    title={message?.title}
                    linkText={message?.action?.text}
                    onLinkClick={() => {
                        if (typeof message?.action?.callback === 'string') {
                            window.location.href = message?.action?.callback;
                        } else {
                            message?.action?.callback();
                        }
                    }}
                >
                    {message.text || message.message}
                </Message>
            ))}
        </div>
    </GridPageLayout>
);
